import React, { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useStyles } from "./Typography.style";
import {
  TypographyColor,
  typographyMapping,
  TypographyVariant,
} from "../../../constants/typography";

export interface ITypographyProps extends HTMLAttributes<HTMLElement> {
  variant?: TypographyVariant;
  color?: TypographyColor;
  inline?: boolean;
  lines?: 0 | 1 | 2 | 3;
  textAlign?: "center" | "left" | "right" | "justify";
}

export const Typography: FC<ITypographyProps> = ({
  variant = TypographyVariant.BodyB1Regular,
  inline = false,
  children,
  textAlign,
  color = TypographyColor.Default,
  lines,
  style,
  ...otherProps
}) => {
  const classes = useStyles();
  return React.createElement(
    inline
      ? "span"
      : typographyMapping[variant ?? TypographyVariant.BodyB1Regular],
    {
      ...otherProps,
      style: {
        ...(textAlign ? { textAlign } : undefined),
        display: inline ? "inline-block" : undefined,
        ...style,
      },
      className: clsx(classes.root, variant, color, otherProps.className, {
        [`lines-${lines}`]: !!lines,
      }),
    },
    children,
  );
};
